import {
    getBikeAllListRequest,
    getBikeAllRequest,
    getBikeNoAccountListRequest,
    getBikeNoAccountRequest,
} from '../../../../services/network/sell/all/bike';

class CommonBikeAllService {
    async getBikeAll(id) {
        return await getBikeAllRequest(id);
    }

    async getBikeAllList(payload) {
        return await getBikeAllListRequest(payload);
    }

    async getBikeNoAccount(id) {
        return await getBikeNoAccountRequest(id);
    }

    async getBikeNoAccountList(payload) {
        return await getBikeNoAccountListRequest(payload);
    }
}

export const BikeAllService = new CommonBikeAllService();
